import React from "react";
import { Col, Row } from "rsuite";
import { BubbleScatterWithZoom } from "./BubbleScatterWithZoom";
import { DivisionWiseTable } from "./DivisionWiseTable";
import { numberFormatter } from "../../utils";

import ScatterCharts from "./ScatterChart";

export default class DivisionData extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    console.log(props);
    this.state = {};
  }

  render() {
    const {
      tableHeight,
      selectedCustomerData,
      scatterData,
      minYAxis,
      maxYAxis,
      recommendationAction,
      handleExecutionPriceChange,
      handleRejectFromCustomerSelect,
      handleAcceptFromCustomerSelect,
    } = this.props;

    const selectReferenceLine = (data: any) => {
      let finalData: any = []
      console.log(data, 12)
      Object.keys(data).map((oneKey, index) => {
        let sum = data[oneKey].reduce((partialSum: any, a: any) => partialSum + a.opportunity, 0)
        finalData.push({ key: oneKey, sum: sum })

      })
      let obj: any = {}
      finalData.sort((a: any, b: any) => b.sum - a.sum)
      finalData.forEach((value: any) => {
        obj[value?.key] = data[value?.key]
      });
      console.log(obj, 'final', finalData)
      return obj
    };

    return (
      <>
        <Col style={{ height: tableHeight }} xs={24} sm={24} md={10}>
          <Row
            style={{ height: "9%", fontSize: "0.69vw" }}
            className="show-grid greenBorder"
          >
            {selectedCustomerData && scatterData ? (
              <>
                <Col style={{ color: "#ffffff" }} xs={24} sm={24} md={15}>
                  Customer:&nbsp;{selectedCustomerData.name}
                </Col>
                <Col style={{ color: "#ffffff" }} xs={24} sm={24} md={9}>
                  Volume:{" "}
                  {numberFormatter(Number(scatterData.summaryData.volume))}
                </Col>
                <Col style={{ color: "#ffffff" }} xs={24} sm={24} md={15}>
                  Revenue: $
                  {numberFormatter(Number(scatterData.summaryData.revenue))}
                </Col>
                <Col style={{ color: "#ffffff" }} xs={24} sm={24} md={9}>
                  Opportunity at Target Price: $
                  {numberFormatter(scatterData.summaryData.opportunity)}
                </Col>
              </>
            ) : (
              <span style={{ lineHeight: "20px" }} className="divTextCenter">
                Click on the left Table to get the Detailed view
              </span>
            )}
          </Row>
          <Row style={{ height: "1%" }} className="show-grid">
            <Col xs={24} sm={24} md={24}></Col>
          </Row>
          <Row style={{ height: "51%" }} className="show-grid greenBorder">
            {scatterData ? (
              <Row
                style={{ height: "5%" }}
                // id="graph"
                className="show-grid"
              >
                <Col style={{ height: "100%" }} xs={24} sm={24} md={24}>
                  <div
                    style={{ height: "100%", fontSize: "12px" }}
                    className="legendDiv"
                  >
                    <span
                      className="dot"
                      style={{
                        backgroundColor:
                          selectedCustomerData?.Customer_Class === "NA"
                            ? "#d3d3d3"
                            : "yellow",
                        height: "10px",
                        width: "10px",
                      }}
                    ></span>
                    <label style={{ paddingRight: "10px" }}>
                      {selectedCustomerData?.Customer_Class === "NA"
                        ? "Peer Set"
                        : "Customer Segment Peer Set"}
                    </label>
                    <span className="expectedPriceLegend">-----</span>
                    <label>Target Price</label>
                    <span
                      className="dot"
                      style={{
                        backgroundColor: "#a4f504",
                        height: "10px",
                        width: "10px",
                      }}
                    ></span>
                    <label style={{ marginRight: "4%" }}>Current Price</label>
                  </div>
                </Col>
              </Row>
            ) : (
              <span className="divTextCenter">
                Click on the left Table to get the Detailed view
              </span>
            )}
            {scatterData && (
              <>
                <Row
                  style={{
                    height: "5%",
                    position: "relative",
                    top: "15px",
                  }}
                  className="show-grid"
                >
                  <Col style={{ width: "12%" }} xs={24} sm={24} md={1} />
                  <Col
                    className="graphTitle"
                    xs={24}
                    sm={24}
                    md={23}
                    style={{ width: "88%", fontSize: "0.55vw" }}
                  >
                    Price comparison by Customers
                  </Col>
                </Row>
                <Row
                  style={{
                    height: "5%",
                    position: "relative",
                    top: "15px",
                  }}
                  className="show-grid"
                >
                  <Col style={{ width: "12%" }} xs={24} sm={24} md={1} />
                  <Col
                    className="graphTitle"
                    xs={24}
                    sm={24}
                    md={23}
                    style={{ width: "88%", fontSize: "1.5vh" }}
                  >
                    <span style={{ color: "#289c45" }}>---</span>5th
                    <span style={{ color: "#3a7048" }}>---</span>25th
                    <span style={{ color: "#344d3a" }}>---</span>50th
                  </Col>
                </Row>
              </>
            )}
            <Row style={{ height: "80%" }} className="show-grid">
              {/* {scatterData &&
                Object.keys(scatterLocal.l4AvgPrice).map((oneKey, index) => {
                  scatterLocal.l4AvgPrice[oneKey].sort(
                    (a: any, b: any) => b.opportunity - a.opportunity
                  );
                  return (
                    <>
                      {index < 5 && (
                        <Col xs={index == 0 ? 6 : 4}>
                          <Row style={{ height: "70%" }}>
                            <BubbleScatterWithZoom
                                  label={"Vol/Drop"}
                                  data={scatterLocal.l4AvgPrice[oneKey]}
                                  graphWidth={window.innerWidth - 275}
                                  graphHeight={window.innerHeight - 275}
                                  minYAxis={minYAxis}
                                  maxYAxis={maxYAxis}
                                  selectedCustomerData={selectedCustomerData}
                                  openPopup={this.state.openPopup}
                                  referenceLine={selectReferenceLine(scatterLocal.l4AvgPrice[oneKey])}
                                  index={index}
                                />
                            <BubbleChartL4Graph
                              data={scatterLocal.l4AvgPrice[oneKey]}
                              selectedCustomerData={selectedCustomerData}
                              referenceLine={selectReferenceLine(scatterLocal.l4AvgPrice[oneKey])}
                              minYAxis={minYAxis}
                              maxYAxis={maxYAxis}
                            />
                          </Row>
                          
                        </Col>
                      )}
                    </>
                  );
                })} */}

              {scatterData && (
                <Row style={{ height: "100%" }}>
                  {/* <BubbleScatterWithZoom
                                  label={"Vol/Drop"}
                                  data={scatterLocal.l4AvgPrice[oneKey]}
                                  graphWidth={window.innerWidth - 275}
                                  graphHeight={window.innerHeight - 275}
                                  minYAxis={minYAxis}
                                  maxYAxis={maxYAxis}
                                  selectedCustomerData={selectedCustomerData}
                                  openPopup={this.state.openPopup}
                                  referenceLine={selectReferenceLine(scatterLocal.l4AvgPrice[oneKey])}
                                  index={index}
                                /> */}
                  <Col xs={24} sm={24} md={24} style={{ height: "100%" }}>
                    <ScatterCharts
                      data={scatterData.l4AvgPrice}
                      selectedCustomerData={selectedCustomerData}
                      minYAxis={minYAxis}
                      maxYAxis={maxYAxis}
                      tableHeight={tableHeight}
                    />

                  </Col>
                </Row>
              )}
            </Row>
          </Row>
          <Row style={{ height: "1%" }} className="show-grid">
            <Col xs={24} sm={24} md={24}></Col>
          </Row>
          <Row style={{ height: "30%" }} className="show-grid greenBorder">
            {scatterData ? (
              <>
                <DivisionWiseTable
                  height={"100%"}
                  scatterData={scatterData}
                  itemExecPrice={this.state.itemExecPrice}
                  itemId={this.state.itemId}
                  selectedCustomerData={selectedCustomerData}
                  recommendationAction={recommendationAction}
                  index={true}
                  handleRejectFromCustomerSelect={
                    handleRejectFromCustomerSelect
                  }
                  handleAcceptFromCustomerSelect={
                    handleAcceptFromCustomerSelect
                  }
                  handleExecutionPriceChange={handleExecutionPriceChange}
                // handleSubmit={this.handleExecPriceChangeSubmit}
                // handleExportPricingReport={
                //   this.handleExportPricingReport
                // }
                />
              </>
            ) : (
              <span className="divTextCenter">
                Click on the left Table to get the Detailed view
              </span>
            )}
          </Row>
        </Col>
      </>
    );
  }
}
